export const server = "https://jixify-one-backend.vercel.app/api/v2";

export const backend_url = "https://jixify-one-backend.vercel.app/";


